import { Head, Link } from "@inertiajs/react"
import { ArrowLeft } from "lucide-react"
import { useTranslation } from "react-i18next"

import { MasterclassModuleForm } from "@/components/masterclasses/masterclass-module-form"
import AppLayout from "@/layouts/app-layout"
import { masterclassPath } from "@/routes"
import type { MasterclassModuleFormProps } from "@/types/masterclasses"

/**
 * OKS-55 — `Brand/Masterclasses/Modules/Edit`.
 *
 * Full-page Edit Module form. Same body as `New`; only the form's
 * `mode` prop + the page title + action verb differ (PATCH vs POST).
 */
export default function MasterclassModulesEdit({
  masterclass,
  masterclass_module,
  mode,
  direct_upload_url,
  cap_hard,
}: MasterclassModuleFormProps) {
  const { t } = useTranslation()

  return (
    <AppLayout>
      <Head title={t("masterclasses.modules.edit_title")} />
      <div
        className="mx-auto flex w-full max-w-5xl flex-col gap-6 p-6"
        data-testid="masterclass-module-edit-page"
      >
        <header className="flex flex-col gap-3">
          <Link
            href={masterclassPath(masterclass.id)}
            className="text-muted-foreground hover:text-foreground inline-flex w-fit items-center gap-1 text-sm"
            data-testid="masterclass-module-edit-back-link"
          >
            <ArrowLeft className="size-4" aria-hidden="true" />
            {masterclass.title ?? t("masterclasses.modules.breadcrumb_root")}
          </Link>
          <h1 className="text-foreground text-2xl font-semibold tracking-tight">
            {t("masterclasses.modules.edit_title")}
          </h1>
        </header>

        <MasterclassModuleForm
          masterclass={masterclass}
          module={masterclass_module}
          mode={mode}
          directUploadUrl={direct_upload_url}
          capHard={cap_hard}
        />
      </div>
    </AppLayout>
  )
}
